import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { TabElement } from '../../core/models/tab-element';

@Component({
    selector: 'app-tab-nav',
    templateUrl: './tab-nav.component.html',
    styleUrls: ['./tab-nav.component.scss'],
})
export class TabNavComponent {
    @Input()
    tabs: TabElement[] = [];

    @Input()
    @HostBinding('style.width')
    styleWidth;

    @Output()
    clicked: EventEmitter<string> = new EventEmitter<string>();

    click(event: Event, tabClicked: TabElement) {
        event.preventDefault();
        event.stopPropagation();
        this.tabs.forEach((tab) => (tab.active = tab.id === tabClicked.id));
        this.clicked.emit(tabClicked.id);
    }
}
